// AccountSocket.jsx
import { useEffect, useContext } from 'react';
import { io } from 'socket.io-client';
import { AuthContext } from './AuthContext'; // Ajusta la ruta si es necesario


function AccountSocket() {
    const { user, logout } = useContext(AuthContext);
  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_URL, { 
    transports: ['websocket']
});


  

    socket.on('account-deleted', (data) => {
        if (data.userId === user?.id_usuario) {
         alert("Tu cuenta ha sido eliminada. Por favor, inicia sesion de nuevo")
          logout();
          window.location.href = '/login';
        }
      });
    return () => {
      socket.disconnect();
    };
  }, [user, logout]);

  return null;
}

export default AccountSocket;
